// extracted by mini-css-extract-plugin
export default {"searchBlock":"Search_searchBlock__AIYtq","searchBlock__title":"Search_searchBlock__title__K-ZP6"};